import React, { useState, useContext, useEffect, useRef } from "react";
import Chrome from "react-color";
import BackShades from "./backGroundShades";
import MyContext from "../../../context/MyContext";
import ProjectContext from "../../../context/ProjectContext";
import axios from "axios";
import AuthContext from "../../../context/userAuth.context";
import swal from "sweetalert";
import Gradient from "./gradient";
import Lottie from "react-lottie";
import loader from "../../../assets/Loader/AssetLoader.json";
import PropsLoader from "../SUBcomponents/Assets/PropsLoader";
import Swal from "sweetalert2";
import Button from '@mui/material/Button';
export const BackgroundsWrapper = () => {
  const ImageUploderRef = useRef(null);
  const { setBackgrounds, Backgrounds, Call_ScreenShot, setCall_ScreenShot } = useContext(MyContext);
  const { authenticationData, Role } = useContext(AuthContext);

  var BackGroundImages = [
    {
      id: 1,
      path: "images/BackGroundImages/1.png",
    },
    {
      id: 2,
      path: "images/BackGroundImages/2.png",
    },
    {
      id: 3,
      path: "images/BackGroundImages/3.png",
    },
    {
      id: 4,
      path: "images/BackGroundImages/4.png",
    },
    {
      id: 5,
      path: "images/BackGroundImages/5.png",
    },
    {
      id: 6,
      path: "images/BackGroundImages/6.png",
    },
    {
      id: 7,
      path: "images/BackGroundImages/7.png",
    },
    {
      id: 8,
      path: "images/BackGroundImages/8.png",
    },
    {
      id: 9,
      path: "images/BackGroundImages/9.png",
    },
    {
      id: 10,
      path: "images/BackGroundImages/10.png",
    },
    {
      id: 11,
      path: "images/BackGroundImages/11.png",
    },
    {
      id: 12,
      path: "images/BackGroundImages/12.png",
    },
  ];

  const [Show, setShow] = useState({
    color: false,
    gradient: false,
    texture: false,
    image: true,
  });

  const [RgbSet, setRgbSet] = useState([]);

  const [colorPick, setcolorPick] = useState("#ffffff");

  const setBackColor = (e, type) => {

    if (type === "color") {

      setBackgrounds({
        type: "color",
        color: e,
        Path: null,
        ImageData: null,
        gradient: { Gcolor: null, FirstColor: null, SecondColor: null },
      });
    } else {
      var splitOne = e.split("0%,");
      var splitTwo = splitOne[0].split("linear-gradient(");
      var splitThree = splitOne[1].split(" 100%)");


      setBackgrounds({
        type: "gradient",
        color: null,
        Path: null,
        ImageData: null,
        gradient: {
          Gcolor: e,
          FirstColor: splitTwo[1],
          SecondColor: splitThree[0],
        },
      });
    }
  };

  useEffect(() => {

    if (Backgrounds) {
      if (Backgrounds.type !== "") {

        if (!Call_ScreenShot) {
          setCall_ScreenShot(true)
        }
      }
    }

  }, [Backgrounds])




  const Color_Touch = (e) => {
    setShow({
      color: true,
      gradient: false,
      texture: false,
      image: false,
    });
  };

  const Gradient_Touch = (e) => {
    setShow({
      color: false,
      gradient: true,
      texture: false,
      image: false,
    });
  };

  const Images_Touch = (e) => {
    setShow({
      color: false,
      gradient: false,
      texture: false,
      image: true,
    });
  };

  const colorChange = (e) => {

    setcolorPick(e.rgb);
  };

  const colorChangeComplete = (e) => {

    setRgbSet(e.rgb);
    setBackColor(e.hex, "color");
  };




  const { BgCategory, setBgCategory } = useContext(MyContext);

  function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
    var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

    return { width: srcWidth * ratio, height: srcHeight * ratio };
  }

  const fileChangeHandle3 = (e) => {
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );
    return new Promise((resolve, reject) => {
      var formdata = new FormData();
      formdata.append("file", e.target.files[0]);

      var reader = new FileReader();
      reader.onload = function (e) {
        let img = new Image();
        img.onload = function () {
          let width = this.width;
          let height = this.height;
          let maxWidth = 300;
          let maxHeight = 168;
          let canvas = document.createElement("canvas");
          let ctx = canvas.getContext("2d");
          var calculatedRatio = calculateAspectRatioFit(
            width,
            height,
            maxWidth,
            maxHeight
          );
          canvas.width = calculatedRatio.width;
          canvas.height = calculatedRatio.height;
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          formdata.append("Image_Low", canvas.toDataURL("image/jpeg"));
          formdata.append("CategoryId", 0);

          axios
            .post(
              authenticationData.ApiBaseURL +
              "/api/Backgrounds/uploadUserBackground",
              formdata,
              {
                headers: {
                  "Content-Type": `multipart/form-data`,
                  "Access-Control-Allow-Origin": "*",
                  Authorization: "Bearer " + authData.access_token,
                },
              }
            )
            .then((response) => {
              if (response.data.result) {
                let arr = Array.from(BgCategory);
                for (let i = 0; i < arr.length; i++) {
                  if (arr[i].id == 0) {
                    arr[i].data = arr[i].data.concat(response.data.result);
                  }
                }
                setBgCategory(arr);
                swal("Excellent", "Image Has Been Uploaded", "success");
                resolve();
              } else {
                swal("Failed", "Unable to Upload Image. Please Try Again", "error");
                resolve();
              }
            })
            .catch((excetion) => {
              swal("Failed", "Unable to Upload Image. Please Try Again", "error");
              reject();
              //console.log(excetion);
            });
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(e.target.files[0]);
    });
  };

  const imageUpload = () => {
    ImageUploderRef.current.click();
  };

  return (
    <div id="backgroundsWrapper" className="innerWrapperPanel">
      <div className="divLabel mb-3">Backgrounds</div>
      <div className="templatesWrapper">
        <section className="tabs" style={{ height: "100%" }}>
          <div style={{ paddingRight: "0px", height: "100%" }}>
            <div style={{ height: "100%", position: "relative" }}>
              <div
                style={{ width: "100%", height: "100%", position: "absolute" }}
              >
                <div className="tabs mb-3">
                  <div className="p2">
                    <div
                      style={{ width: "33%" }}
                      className={
                        "tabButton" +
                        (!Show.color &&
                          !Show.gradient &&
                          !Show.texture &&
                          Show.image
                          ? " activeTab"
                          : "")
                      }
                      onClick={Images_Touch}
                    >
                      Backgrounds
                    </div>
                    <div
                      style={{ width: "33%" }}
                      className={
                        "tabButton" +
                        (Show.color &&
                          !Show.gradient &&
                          !Show.texture &&
                          !Show.image
                          ? " activeTab"
                          : "")
                      }
                      onClick={Color_Touch}
                    >
                      Color
                    </div>
                    <div
                      style={{ width: "33%" }}
                      className={
                        "tabButton" +
                        (!Show.color &&
                          Show.gradient &&
                          !Show.texture &&
                          !Show.image
                          ? " activeTab"
                          : "")
                      }
                      onClick={Gradient_Touch}
                    >
                      Gradients
                    </div>
                  </div>
                </div>

                {Show.image === true && Role !== "admin" && (
                  <div className="image_uploader">
                    <div
                      onClick={imageUpload}
                      className="image_uploader_inner"
                      style={{ marginBottom: "10px" }}
                    >
                      <div className="Image_uploader_text">
                        <div className="flex">
                          <span className="material-icons customBtnIcon">
                            upload
                          </span>
                          Upload Backgrounds
                        </div>

                        <input
                          ref={ImageUploderRef}
                          hidden
                          type="file"
                          accept="image/png, image/jpeg"
                          onChange={fileChangeHandle3}
                        ></input>
                      </div>
                    </div>
                  </div>
                )}
                {Backgrounds.Path != null &&
                  <Button size="medium" style={{ marginBottom: '10px', width: '92%', marginLeft: '14px' ,textTransform: 'none'}} variant="contained"
                    onClick={() => {
                      setBackgrounds({
                        type: "removed",
                        color: null,
                        Path: null,
                        gradient: { Gcolor: null, FirstColor: null, SecondColor: null }
                      });
                    }}>
                    Remove Background
                  </Button>
                }

                <div
                  style={{ height: "100%" }}
                  className="tab-content px-3 px-sm-0"
                >
                  {Show.color === true && (
                    <div
                      className="tab-pane fade show active scrollbar style-1"
                      id="bg-colors"
                      role="tabpanel"
                      aria-labelledby="bg-colors-tab"
                    >
                      <div>
                        <div className="main-bg-colors">
                          <div className="BackShades">
                            <BackShades
                              setcolorPick={setcolorPick}
                              RgbSet={RgbSet}
                            />
                          </div>

                          <div>
                            <Chrome
                              disableAlpha={true}
                              color={colorPick}
                              onChange={colorChange}
                              onChangeComplete={colorChangeComplete}
                              className="PickerSize"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {Show.gradient === true && (
                    <div
                      className="tab-pane fade show active scrollbar style-1"
                      id="bg-gradients"
                      role="tabpanel"
                      aria-labelledby="bg-gradients-tab"
                      style={{ height: "calc(100% - 128px)" }}
                    >
                      <div style={{ paddingRight: "0px" }}>
                        <Gradient setBackColor={setBackColor} />
                      </div>
                    </div>
                  )}

                  {Show.image === true && (
                    <>
                      <BackgroundParentCartoon />
                      {/* <BackGroundsParent/>     */}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
export default BackgroundsWrapper;

const BackgroundParentCartoon = () => {
  const { authenticationData } = useContext(AuthContext);

  const { BgCategory, setBgCategory } = useContext(MyContext);

  useEffect(() => {

    if (BgCategory.length < 2) {
      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      axios
        .get(
          authenticationData.ApiBaseURL + "/api/Backgrounds/GetBgCategories",
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          if (response.data.categories) {
            let arr = [];
            for (let i = 0; i < response.data.categories.length; i++) {
              let obj = {
                id: 0,
                name: "",
                ImagePath: "",
                data: [],
              };

              obj.id = response.data.categories[i].id;
              obj.name = response.data.categories[i].categoryName;
              obj.ImagePath = response.data.categories[i].defaultImgPath;
              obj.data = [];
              //if (obj.name === "Cartoon Background") {
              arr.push(obj);
              // }
            }

            //BgCategory.splice(0, BgCategory.length);
            setBgCategory(BgCategory.concat(arr));
          }
        })
        .catch((error) => {
          //console.log(error);
        });
    }
  }, []);

  return (
    <>
      <div
        className="style-1"
        style={{
          height: "calc(100% - 170px)",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        {BgCategory.length != 0 &&
          BgCategory.map((lmc, index) => {
            return <BackGroundChild lmc={lmc} key={index.toString()} />;
          })}
      </div>
    </>
  );
};

const BackGroundsParent = ({ }) => {
  const { authenticationData } = useContext(AuthContext);

  const { BgCategory, setBgCategory } = useContext(MyContext);

  useEffect(() => {
    if (BgCategory.length < 2) {
      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      axios
        .get(
          authenticationData.ApiBaseURL + "/api/Backgrounds/GetBgCategories",
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          if (response.data.categories) {
            let arr = [];

            for (let i = 0; i < response.data.categories.length; i++) {
              let obj = {
                id: 0,
                name: "",
                ImagePath: "",
                data: [],
              };

              obj.id = response.data.categories[i].id;
              obj.name = response.data.categories[i].categoryName;
              obj.ImagePath = response.data.categories[i].defaultImgPath;
              obj.data = [];
              arr.push(obj);
            }
            setBgCategory(BgCategory.concat(arr));
          }
        })
        .catch((error) => {
          //console.log(error);
        });
    }
  }, []);

  return (
    <>
      <div
        className="style-1"
        style={{ height: "calc(100% - 119px)", overflowY: "scroll" }}
      >
        {BgCategory.length != 0 &&
          BgCategory.map((lmc, index) => {
            return <BackGroundChild lmc={lmc} key={index.toString()} />;
          })}
      </div>
    </>
  );
};

const BackGroundChild = ({ lmc }) => {
  const { authenticationData, Access } = useContext(AuthContext);

  const [ShowItems, setShowItems] = useState(false);

  return (
    <>
      <div className="CharacterShow2">
        <div className="character_container" style={{ background: "#ffffff" }}>
          <div className="character_container_insider">
            <div className="Chr_cont_folder">
              <div className="chr_cont_name ">{lmc.name}
                {Access === "FE" && (lmc.id == 8 || lmc.id == 1) && (
                  <img
                    style={{
                      position: "absolute",
                      top: "0px",
                      right: "142px",
                      width: "20px",
                      height: "20px",
                      zIndex: "1",
                    }}
                    src="../AppIcons/IconsAll/PremiumIcon.svg"
                    alt=""
                  />
                )}
              </div>

              <div
                className="Chr_folder_insider "
                onClick={() => {
                  setShowItems(!ShowItems);
                }}
              >
                <span
                  className="maskclas"
                  style={{ background: "#ffffff" }}
                ></span>

                <img
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  src={authenticationData.ApiBaseURL + "/" + lmc.ImagePath}
                  alt=""
                />
              </div>
              <div
                className="folderExpand"
                onClick={() => {
                  setShowItems(!ShowItems);
                }}
              >
                {ShowItems && (
                  <span
                    style={{
                      top: "7px",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                    className="material-icons folderExpand_icon"
                  >
                    close
                  </span>
                )}
                {!ShowItems && (
                  <span
                    style={{
                      top: "9px",
                      right: "12px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    className="material-icons folderExpand_icon"
                  >
                    expand_more
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {ShowItems && <BackgroundWrap id={lmc.id} lmc={lmc} />}
    </>
  );
};

const BackgroundWrap = ({ id, lmc }) => {
  const { authenticationData, Role } = useContext(AuthContext);
  const { BgCategory, setBgCategory } = useContext(MyContext);
  const [MyLoader, setMyLoader] = useState(false);

  useEffect(() => {
    // if (lmc.name === "Animated Backgrounds") {
    //   return;
    // }


    if (lmc.data.length == 0) {
      setMyLoader(true);
      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );

      if (lmc.name == "User Backgrounds") {
        axios
          .get(authenticationData.ApiBaseURL + "/api/Backgrounds/GetUserBgs", {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          })
          .then((response) => {
            if (response.data) {
              let arr = Array.from(BgCategory);

              for (let i = 0; i < arr.length; i++) {
                if (arr[i].id == id) {
                  arr[i].data = response.data.backgrounds;
                }
              }
              setBgCategory(arr);
              setMyLoader(false);
            }
          })
          .catch((error) => {
            //console.log(error);
            setMyLoader(false);
          });
      } else {
        axios
          .get(
            authenticationData.ApiBaseURL +
            "/api/Backgrounds/GetDefaultBgs?id=" +
            id,
            {
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
          .then((response) => {
            if (response.data.backgrounds != null) {
              let arr = Array.from(BgCategory);

              for (let i = 0; i < arr.length; i++) {
                if (arr[i].id == id) {
                  arr[i].data = response.data.backgrounds;
                }
              }
              setBgCategory(arr);
              setMyLoader(false);
            }
          })
          .catch((error) => {
            //console.log(error);
            setMyLoader(false);
          });
      }
    }
  }, []);
  const ImageUploderAnimatedRef = useRef(null);
  const ImageUploderRef = useRef(null);

  function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
    var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

    return { width: srcWidth * ratio, height: srcHeight * ratio };
  }

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  const fileChangeHandle3 = async (e) => {
    let files = e.target.files;
    for (let i = 0; i < files.length; i++) {
      await name(e.target.files[i]);
    }

    swal("Excellent", "All Backgrounds Has Been Uploaded", "success");
  };

  const fileHandleAnimated = (e) => {

    var formdata = new FormData();
    for (var i = 0; i < e.target.files.length; i++) {
      formdata.append("file", e.target.files[i]);
    }
    formdata.append("CategoryId", 1);
    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Backgrounds/UploadAnimatedBackground",
        formdata,
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {

        alert(response.data.result);

      })
      .catch((excetion) => {

      });


  };

  const name = (file) => {
    return new Promise((resolve, reject) => {
      var formdata = new FormData();
      formdata.append("file", file);

      var reader = new FileReader();
      reader.onload = function (e) {
        let img = new Image();
        img.onload = function () {
          let width = this.width;
          let height = this.height;
          let maxWidth = 300;
          let maxHeight = 168;
          let canvas = document.createElement("canvas");
          let ctx = canvas.getContext("2d");
          var calculatedRatio = calculateAspectRatioFit(
            width,
            height,
            maxWidth,
            maxHeight
          );
          canvas.width = calculatedRatio.width;
          canvas.height = calculatedRatio.height;
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          formdata.append("Image_Low", canvas.toDataURL("image/jpeg"));
          formdata.append("CategoryId", id);

          axios
            .post(
              authenticationData.ApiBaseURL +
              "/api/Backgrounds/uploadUserBackground",
              formdata,
              {
                headers: {
                  "Content-Type": `multipart/form-data`,
                  "Access-Control-Allow-Origin": "*",
                  Authorization: "Bearer " + authData.access_token,
                },
              }
            )
            .then((response) => {
              if (response.data.result) {
                let arr = Array.from(BgCategory);
                for (let i = 0; i < arr.length; i++) {
                  if (arr[i].id == id) {
                    arr[i].data = arr[i].data.concat(response.data.result);
                  }
                }
                setBgCategory(arr);
                resolve();
              } else {
                resolve();
              }
            })
            .catch((excetion) => {
              reject();
              //console.log(excetion);
            });
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  };

  const imageUpload = () => {
    if (ImageUploderRef.current != undefined) ImageUploderRef.current.click();
  };

  const imageUploadAnimated = () => {
    if (ImageUploderAnimatedRef.current != undefined)
      ImageUploderAnimatedRef.current.click();
  };

  return (
    <>
      <div className="Character_folder_items">
        <div className="chr_cont_name text-center">
          Showing results for: {lmc.name}
        </div>
        <div style={{ width: "100%", height: "auto" }}>
          <div className="seperator">
            <div className="Char_assetsList">
              {Role == "admin" &&
                lmc.name != "Animated Backgrounds" &&
                id != 0 && (
                  <div className="image_uploader">
                    <div onClick={imageUpload} className="image_uploader_inner">
                      <div className="Image_uploader_text">
                        <div>Upload Image</div>
                        <input
                          ref={ImageUploderRef}
                          type="file"
                          multiple
                          hidden
                          onChange={fileChangeHandle3}
                          accept="image/png, image/jpeg"
                        ></input>
                      </div>
                    </div>
                  </div>
                )}

              {Role == "admin" &&
                lmc.name === "Animated Backgrounds" &&
                id === 1 && (
                  <div className="image_uploader">
                    <div
                      onClick={imageUploadAnimated}
                      className="image_uploader_inner"
                    >
                      <div className="Image_uploader_text">
                        <div>Upload Animated Background</div>
                        <input
                          ref={ImageUploderAnimatedRef}
                          type="file"
                          multiple
                          hidden
                          onChange={fileHandleAnimated}
                          accept=".json,.png"
                        ></input>
                      </div>
                    </div>
                  </div>
                )}

              {/* {lmc.items && Loader == true && SlideData.length == 0 && (
          <Lottie options={{ loop: true, autoplay: true, animationData: loader }}
            height={200}
            width={200}
            isStopped={false}
            isPaused={false}
          /> )} */}

              {lmc.name != "Animated Backgrounds" &&
                lmc.data.length != 0 &&
                lmc.data.map((obj, index) => {
                  return <BackPics obj={obj} key={index} />;
                })}

              {lmc.name === "Animated Backgrounds" &&
                lmc.data.length != 0 &&
                lmc.data.map((obj, index) => {
                  return (
                    <PropsLoader
                      key={index}
                      ImgPath={obj.image_Low}
                      name={lmc.name}
                      ind={index}
                      Item_Path={obj.imagePath}
                    />
                  );
                })}

              {MyLoader == true && lmc.data.length == 0 && (
                <Lottie
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: loader,
                  }}
                  height={200}
                  width={200}
                  isStopped={false}
                  isPaused={false}
                />
              )}

              {lmc.data.length == 0 && MyLoader == false && (
                <div
                  style={{
                    margin: "0 auto",
                    width: "100%",
                  }}
                >
                  <div className="Character_folder_items">
                    <p className="displayMsg">No item available currently.</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const BackPics = ({ index, obj }) => {
  const { authenticationData, Access, getLink } = useContext(AuthContext);

  const { setBackgrounds, Call_ScreenShot, setCall_ScreenShot } = useContext(MyContext);
  const { ChangeCount, setChangeCount, slides } = useContext(ProjectContext);

  const setData = (data) => {

    // const loadImage = url => {
    //   return new Promise((resolve, reject) => {
    //     var image = new Image();
    //     image.onload = function () {
    //       resolve(image)
    //     }
    //     image.src = url;
    //   });
    // };
    // loadImage(data).then((image) => {
    //   setBackgrounds({ type: 'image', color: null, Path: data, ImageData: image, gradient: { Gcolor: null, FirstColor: null, SecondColor: null } })
    //   setChangeCount(ChangeCount + 1)
    // });


    if (Access === "FE" && data.categoryId == 8) {
      Swal.fire({
        title: "Upgrade Required",
        html:
          `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
        icon: "info",
        cancelButtonColor: "#d33",
        backdrop: null,
      });
      return;
    }

    if (!Call_ScreenShot) {
      setCall_ScreenShot(true)
    }

    setBackgrounds({
      type: "image",
      color: null,
      Path: data.imagePath,
      gradient: { Gcolor: null, FirstColor: null, SecondColor: null },
    });
    setChangeCount(ChangeCount + 1);
  };





  return (
    <>
      <div
        key={index}
        className="Asset_items slide-loader-wrapper"
        style={{ flexBasis: "46.8%", position: "relative", height: "100%" }}
      >
        {Access === "FE" && obj.categoryId == 8 && (
          <img
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              width: "20px",
              height: "20px",
              zIndex: "1",
            }}
            src="../AppIcons/IconsAll/PremiumIcon.svg"
            alt=""
          />
        )}

        <img
          src={authenticationData.ApiBaseURL + "/" + obj.image_Low}
          style={{ width: "100%", borderRadius: "10px" }}
          //onClick={() => setData(authenticationData.ApiBaseURL + '/' + obj.imagePath)}
          onClick={() => setData(obj)}
        />
      </div>
    </>
  );
};
